/**
 * FikoBukum Dialog — Sac Metal Büküm Açınımı (Flat Pattern) UI
 * Flanş + büküm → düz açınım boyu. Abkant/lazer için.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BukumOge, bukumHesapla, BukumSonuc } from './FikoBukum';

@Component({
  selector: 'fikoyt-bukum',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="bk">
    <div class="bk-ust">
      <div class="bk-in"><label>Kalınlık t (mm)</label><input type="number" [(ngModel)]="kalinlik" (ngModelChange)="hesapla()" min="0.1" step="0.1"></div>
      <div class="bk-in"><label>K-faktör</label><input type="number" [(ngModel)]="kFaktor" (ngModelChange)="hesapla()" min="0" max="0.5" step="0.01"></div>
    </div>

    <div class="bk-baslik">Açınım zinciri (flanş → büküm → flanş...)</div>
    <div class="bk-zincir">
      @for (f of flanslar; track $index; let i = $index) {
        <div class="bk-flans">
          <span class="bk-et">Flanş {{ i + 1 }}</span>
          <input type="number" [(ngModel)]="flanslar[i]" (ngModelChange)="hesapla()" min="0"><span class="bk-mm">mm</span>
          <button class="bk-sil" (click)="flansSil(i)">✕</button>
        </div>
        @if (i < bukumler.length) {
          <div class="bk-bukum">
            <span class="bk-et">↳ Büküm {{ i + 1 }}</span>
            <input type="number" [(ngModel)]="bukumler[i].aci" (ngModelChange)="hesapla()" min="0" title="Açı °"><span class="bk-mm">°</span>
            <input type="number" [(ngModel)]="bukumler[i].icYaricap" (ngModelChange)="hesapla()" min="0" step="0.1" title="İç yarıçap"><span class="bk-mm">r</span>
            <span class="bk-ba">BA {{ ba(i) }}</span>
          </div>
        }
      }
    </div>
    <button class="bk-mini" (click)="bukumEkle()">＋ Büküm + Flanş Ekle</button>

    @if (sonuc) {
      <div class="bk-sonuc">
        <div class="bk-r"><span>Flanş toplamı</span><b>{{ f(sonuc.toplamFlans) }} mm</b></div>
        <div class="bk-r"><span>Büküm payı (Σ BA)</span><b>{{ f(sonuc.toplamBA) }} mm</b></div>
        <div class="bk-r"><span>Büküm sayısı</span><b>{{ sonuc.bukumSayisi }}</b></div>
        <div class="bk-r flat"><span>DÜZ AÇINIM BOYU</span><b>{{ f(sonuc.flatBoy) }} mm</b></div>
      </div>
      <div class="bk-not">💡 Sac bu boyda kesilip {{ sonuc.bukumSayisi }} büküm yapılır. K-faktör malzeme/abkanta göre ayarlanır (yumuşak çelik ~0.33).</div>
    }
  </div>
  `,
  styles: [`
    .bk { padding:10px; min-width:300px; max-width:340px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .bk-ust { display:flex; gap:8px; margin-bottom:8px; }
    .bk-in { display:flex; flex-direction:column; gap:2px; flex:1; }
    .bk-in label { font-size:9px; color:#5fd9f5; }
    .bk-in input, .bk-flans input, .bk-bukum input { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; outline:none; box-sizing:border-box; }
    .bk-baslik { color:#5fd9f5; font-weight:600; margin:4px 0; font-size:10px; }
    .bk-zincir { display:flex; flex-direction:column; gap:3px; }
    .bk-flans, .bk-bukum { display:flex; align-items:center; gap:5px; }
    .bk-flans input { width:70px; } .bk-bukum input { width:48px; }
    .bk-bukum { padding-left:10px; opacity:.92; }
    .bk-et { font-size:10px; color:#9fe8f7; min-width:62px; }
    .bk-mm { font-size:9px; color:#7fc6dd; }
    .bk-ba { font-size:9px; color:#ffd76a; margin-left:auto; }
    .bk-sil { background:rgba(120,40,40,.6); border:1px solid rgba(255,100,100,.4); color:#ff9a9a; border-radius:4px; cursor:pointer; margin-left:auto; }
    .bk-mini { width:100%; margin-top:6px; background:rgba(0,90,110,.6); border:1px solid rgba(0,200,220,.4); color:#bdf; border-radius:4px; padding:5px; font-size:10px; cursor:pointer; }
    .bk-mini:hover { background:rgba(0,130,160,.8); }
    .bk-sonuc { margin-top:10px; background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); border-radius:5px; padding:8px; }
    .bk-r { display:flex; justify-content:space-between; padding:3px 0; border-bottom:1px solid rgba(0,200,220,.12); }
    .bk-r span { color:#9fe8f7; }
    .bk-r.flat { background:rgba(0,200,120,.16); margin:4px -8px -2px; padding:6px 8px; border:none; } .bk-r.flat b { color:#7dffc0; font-size:14px; }
    .bk-not { margin-top:8px; font-size:9px; color:#9fe8f7; line-height:1.4; }
  `]
})
export class FikoBukumComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};

  kalinlik = 2; kFaktor = 0.33;
  flanslar: number[] = [50, 30];
  bukumler: BukumOge[] = [{ aci: 90, icYaricap: 2 }];
  sonuc: BukumSonuc | null = null;

  constructor(private cd: ChangeDetectorRef) { this.sonuc = this.hesaplaInt(); }

  private hesaplaInt(): BukumSonuc { return bukumHesapla({ kalinlik: this.kalinlik, kFaktor: this.kFaktor, flanslar: this.flanslar, bukumler: this.bukumler }); }
  hesapla(): void { this.sonuc = this.hesaplaInt(); this.cd.detectChanges(); }
  ba(i: number): string { return (this.sonuc?.bendAllowances[i] ?? 0).toFixed(2); }

  bukumEkle(): void { this.bukumler.push({ aci: 90, icYaricap: this.kalinlik }); this.flanslar.push(30); this.hesapla(); }
  flansSil(i: number): void {
    if (this.flanslar.length <= 1) return;
    this.flanslar.splice(i, 1);
    if (this.bukumler.length) this.bukumler.splice(Math.min(i, this.bukumler.length - 1), 1);
    this.hesapla();
  }

  f(v: number, d = 2): string { return (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: d }); }
}
